import { Box } from "@mui/material"
import { useSelector } from "react-redux"

const MainContainer = ({ children, sx }) => {
  const isStaffPhysician = useSelector(state => state.isStaffPhysician)
  const isAdminStaffPhysician = useSelector(state => state.isAdminStaffPhysician)
  return (
    <Box
      sx={{
        // bgcolor: { md: 'background.white' },
        // height: 'calc(100vh - 80px)',
        width: '100%',
        flexGrow: 1,
        borderRadius: { md: '24px 0 0 24px' },
        padding: { md: '24px 16px 50px' },
        paddingBottom: isStaffPhysician || isAdminStaffPhysician ? '94px' : 0,
        ...sx
      }}
      className='main-container'
    >
      {children}
    </Box>
  )
}

export default MainContainer